export default {
    cn: {
        salesMonthlyResult: {
            indexText: '销售月结佣金结果',
            text: '销售月结佣金计算结果',
            datailText: '销售月结佣金计算结果明细',
            goback: '返回',
            start_time: "开始时间：",
            end_time: "结束时间：",
            selectTimeText: '选择日期',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            downloadExcelForms: "下载 Excel",
            downloadDetailExcel: "下载明细",
            nodata: "没有查询到数据",
            search: '搜索',
            commissionType: '佣金类别：',
            salesAccount: '销售账号：',
            status: '状态：',
            confirm: '佣金确定',
            reject: '佣金拒绝',
            rejectMessage: '请输入拒绝原因',
            spread: '展开',
            fold: '折叠',
            commit: '您真的要确定/拒绝吗?',
            downloadName: '销售月结佣金明细',
            selectKeys: { "id": "销售账号", "depositAccount": "入金账号" },
            typeList: { "-1": "所有", "0": "月结佣金", "1": "下层返佣" },
            statusList: { "-1": "所有", "2": "未确定", "3": "已确定", "4": "已拒绝" },
            indexStatusList: { "-1": "所有", "0": "未确定", "1": "全部确定", "2": "部分确定" },
            levelObj: { UN: '系统', C: '公司', N: '国家', R: '地区', O: '办事处', M: '经理', SL: '销售', IB: '代理', CL: '客户' },
            client_type: { "0": "全部客户", "1": "代理", "2": "直客", "3": "直客(VIP)", "4": "代理(VIP)" },
            indexTh: [
                { key: 'REPORT_ID', name: '编号' },
                { key: 'saleCommResult', name: '销售佣金结果', unneed: false },
                { key: 'DATE_FROM', name: '开始时间' },
                { key: 'DATE_TO', name: '结束时间' },
                { key: 'LAST_UPDATE', name: '完成时间', changeTime: true },
                { key: 'status', name: '状态' }
            ],
            detailTotal: {
                TOTAL_LOTS: '合计手数',
                TOTAL_REBATE: '每手佣金',
                TOTAL_COMMISSION: '员工所得佣金',
                TOTAL: '的月结佣金',
                index: 2,
                part: 'part'
            },
            total: { total: '合计', index: 1, part: 'part' },
            commmissionTh: [
                { key: 'type', name: '佣金类别' },
                { key: 'SALES_ID', name: '销售账号' },
                { key: 'NAME', name: '销售姓名' },
                { key: 'level', name: '级别' },
                { key: 'AMOUNT', name: '金额' },
                { key: 'status', name: '状态' },
                { key: 'REJECT_REASON', name: '拒绝原因' },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' },
                { key: 'DEPOSIT_COMMENT', name: '佣金注解' },
                { key: 'UPDATE_BY', name: '最后更新' },
                { key: 'LAST_UPDATE', name: '更新时间', changeTime: true }
            ],
            commmissionTh_v2: [
                { key: 'type', name: '佣金类别' },
                { key: 'SALES_ID', name: '销售账号' },
                { key: 'NAME', name: '销售姓名' },
                { key: 'level', name: '级别' },
                { key: 'DEPOSIT_PLATFORM', name: '交易平台' },
                { key: 'DEPOSIT_ACCOUNT_ID', name: '入金账号' },
                { key: 'AMOUNT', name: '金额' },
                { key: 'status', name: '状态' },
                { key: 'REJECT_REASON', name: '拒绝原因' },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' },
                { key: 'DEPOSIT_COMMENT', name: '佣金注解' },
                { key: 'UPDATE_BY', name: '最后更新' },
                { key: 'LAST_UPDATE', name: '更新时间', changeTime: true }
            ],
            downloadTh: [
                { key: 'TYPE', name: '佣金类别' },
                { key: 'SALES_ID', name: '销售账号' },
                { key: 'NAME', name: '销售姓名' },
                { key: 'LEVEL', name: '级别' },
                { key: 'AMOUNT', name: '金额' },
                { key: 'ID', name: '账号' },
                { key: 'LOW_LEVEL', name: '级别' },
                { key: 'CLIENT_TYPE', name: '客户类别' },
                { key: 'TOTAL_VOLUME', name: '交易量' },
                { key: 'REBATE', name: '每手佣金' },
                { key: 'TOTAL_COMMISSION', name: '所得金额' }
            ],
            downloadTh_v2: [
                { key: 'TYPE', name: '佣金类别' },
                { key: 'SALES_ID', name: '销售账号' },
                { key: 'NAME', name: '销售姓名' },
                { key: 'LEVEL', name: '级别' },
                { key: 'AMOUNT', name: '金额' },
                { key: 'ID', name: '账号' },
                { key: 'DEPOSIT_ACCOUNT', name: '代理入金账号' },
                { key: 'LOW_LEVEL', name: '级别' },
                { key: 'CLIENT_TYPE', name: '客户类别' },
                { key: 'PLATFORM', name: '交易平台' },
                { key: 'TOTAL_VOLUME', name: '交易量' },
                { key: 'REBATE', name: '每手佣金' },
                { key: 'TOTAL_COMMISSION', name: '所得金额' }
            ],
            lowerTh: [
                { key: 'sub_sales_id', name: '下层销售账号' },
                { key: 'NAME', name: '销售姓名' },
                { key: 'level', name: '级别' },
                { key: 'rule_id', name: '规则' },
                { key: 'VALUE', name: '规则参数' },
                { key: 'client_type', name: '客户类别' },
                { key: 'TOTAL_VOLUME', name: '总手数' },
                { key: 'RULE_COMMISSION', name: '总金额' }
            ],
            detailTh: {
                IB_ID: '代理账号',
                CLIENT_ID: '客户账号',
                FX_LOT: '外汇(手数)',
                FX_REBATE: '外汇(每手佣金)',
                FX_COMMISSION: '外汇(内佣)',
                GOLD_LOT: '黄金(手数)',
                GOLD_REBATE: '黄金(每手佣金)',
                GOLD_COMMISSION: '黄金(内佣)',
                SILVER_LOT: '白银(手数)',
                SILVER_REBATE: '白银(每手佣金)',
                SILVER_COMMISSION: '白银(内佣)',
                ENERGY_LOT: '能源(手数)',
                ENERGY_REBATE: '能源(每手佣金)',
                ENERGY_COMMISSION: '能源(内佣)',
                INDEX_LOT: '指数(手数)',
                INDEX_REBATE: '指数(每手佣金)',
                INDEX_COMMISSION: '指数(内佣)'
            },
            detailTh_v2: {
                IB_ID: '代理账号',
                PLATFORM: '交易平台',
                CLIENT_ID: '客户账号',
                TRADING_ACCOUNT_ID: '交易账号',
                FX_LOT: '外汇(手数)',
                FX_REBATE: '外汇(每手佣金)',
                FX_COMMISSION: '外汇(内佣)',
                GOLD_LOT: '黄金(手数)',
                GOLD_REBATE: '黄金(每手佣金)',
                GOLD_COMMISSION: '黄金(内佣)',
                SILVER_LOT: '白银(手数)',
                SILVER_REBATE: '白银(每手佣金)',
                SILVER_COMMISSION: '白银(内佣)',
                ENERGY_LOT: '能源(手数)',
                ENERGY_REBATE: '能源(每手佣金)',
                ENERGY_COMMISSION: '能源(内佣)',
                INDEX_LOT: '指数(手数)',
                INDEX_REBATE: '指数(每手佣金)',
                INDEX_COMMISSION: '指数(内佣)'
            }
        }
    },
    hk: {
        salesMonthlyResult: {
            indexText: '銷售月結佣金結果',
            text: '銷售月結佣金計算結果',
            datailText: '銷售月結佣金計算結果明細',
            goback: '返回',
            start_time: "開始時間：",
            end_time: "結束時間：",
            selectTimeText: '選擇日期',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            downloadExcelForms: "下載 Excel",
            downloadDetailExcel: "下載明細",
            search: "搜索",
            nodata: "沒有查詢到數據",
            commissionType: '佣金類別：',
            salesAccount: '銷售賬號：',
            status: '狀態：',
            confirm: '佣金確定',
            reject: '佣金拒絕',
            rejectMessage: '請輸入拒絕原因',
            spread: '展開',
            fold: '摺疊',
            commit: '您真的要確定/拒絕嗎?',
            downloadName: '銷售月結佣金明細',
            selectKeys: { "id": "銷售賬號", "depositAccount": "入金賬號" },
            typeList: { "-1": "所有", "0": "月結佣金", "1": "下層返佣" },
            statusList: { "-1": "所有", "2": "未確定", "3": "已確定", "4": "已拒絕" },
            indexStatusList: { "-1": "所有", "0": "未確定", "1": "全部確定", "2": "部分確定" },
            client_type: { "0": "全部客戶", "1": "代理", "2": "直客", "3": "直客(VIP)", "4": "代理(VIP)" },
            levelObj: {
                UN: '系統',
                C: '公司',
                N: '國家',
                R: '地區',
                O: '辦事處',
                M: '經理',
                SL: '銷售',
                IB: '代理',
                CL: '客戶'
            },
            indexTh: [
                { key: 'REPORT_ID', name: '編號' },
                { key: 'saleCommResult', name: '銷售佣金結果', unneed: false },
                { key: 'DATE_FROM', name: '開始時間' },
                { key: 'DATE_TO', name: '結束時間' },
                { key: 'LAST_UPDATE', name: '完成時間', changeTime: true },
                { key: 'status', name: '狀態' }
            ],
            detailTotal: {
                TOTAL_LOTS: '合計手數',
                TOTAL_REBATE: '每手佣金',
                TOTAL_COMMISSION: '員工所得佣金',
                TOTAL: '的月結佣金',
                index: 2,
                part: 'part'
            },
            total: { total: '合計', index: 1, part: 'part' },
            commmissionTh: [
                { key: 'type', name: '佣金類別' },
                { key: 'SALES_ID', name: '銷售賬號' },
                { key: 'NAME', name: '銷售姓名' },
                { key: 'level', name: '級別' },
                { key: 'AMOUNT', name: '金額' },
                { key: 'status', name: '狀態' },
                { key: 'REJECT_REASON', name: '拒絕原因' },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' },
                { key: 'DEPOSIT_COMMENT', name: '佣金注解' },
                { key: 'UPDATE_BY', name: '最後更新' },
                { key: 'LAST_UPDATE', name: '更新時間', changeTime: true }
            ],
            commmissionTh_v2: [
                { key: 'type', name: '佣金類別' },
                { key: 'SALES_ID', name: '銷售賬號' },
                { key: 'NAME', name: '銷售姓名' },
                { key: 'level', name: '級別' },
                { key: 'DEPOSIT_PLATFORM', name: '交易平台' },
                { key: 'DEPOSIT_ACCOUNT_ID', name: '入金賬號' },
                { key: 'AMOUNT', name: '金額' },
                { key: 'status', name: '狀態' },
                { key: 'REJECT_REASON', name: '拒絕原因' },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' },
                { key: 'DEPOSIT_COMMENT', name: '佣金注解' },
                { key: 'UPDATE_BY', name: '最後更新' },
                { key: 'LAST_UPDATE', name: '更新時間', changeTime: true }
            ],
            downloadTh: [
                { key: 'TYPE', name: '佣金類別' },
                { key: 'SALES_ID', name: '銷售賬號' },
                { key: 'NAME', name: '销售姓名' },
                { key: 'LEVEL', name: '級別' },
                { key: 'AMOUNT', name: '金額' },
                { key: 'ID', name: '賬號' },
                { key: 'LOW_LEVEL', name: '級別' },
                { key: 'CLIENT_TYPE', name: '客戶類別' },
                { key: 'TOTAL_VOLUME', name: '交易量' },
                { key: 'REBATE', name: '每手佣金' },
                { key: 'TOTAL_COMMISSION', name: '所得金額' }
            ],
            downloadTh_v2: [
                { key: 'TYPE', name: '佣金類別' },
                { key: 'SALES_ID', name: '銷售賬號' },
                { key: 'NAME', name: '销售姓名' },
                { key: 'LEVEL', name: '級別' },
                { key: 'AMOUNT', name: '金額' },
                { key: 'ID', name: '賬號' },
                { key: 'DEPOSIT_ACCOUNT', name: '代理入金賬號' },
                { key: 'LOW_LEVEL', name: '級別' },
                { key: 'CLIENT_TYPE', name: '客戶類別' },
                { key: 'PLATFORM', name: '交易平台' },
                { key: 'TOTAL_VOLUME', name: '交易量' },
                { key: 'REBATE', name: '每手佣金' },
                { key: 'TOTAL_COMMISSION', name: '所得金額' }
            ],
            lowerTh: [
                { key: 'sub_sales_id', name: '下層銷售賬號' },
                { key: 'NAME', name: '銷售姓名' },
                { key: 'level', name: '級別' },
                { key: 'rule_id', name: '規則' },
                { key: 'VALUE', name: '規則參數' },
                { key: 'client_type', name: '客戶類別' },
                { key: 'TOTAL_VOLUME', name: '總手數' },
                { key: 'RULE_COMMISSION', name: '總金額' }
            ],
            detailTh: {
                IB_ID: '代理賬號',
                CLIENT_ID: '客戶賬號',
                FX_LOT: '外匯(手數)',
                FX_REBATE: '外匯(每手佣金)',
                FX_COMMISSION: '外匯(內佣)',
                GOLD_LOT: '黃金(手數)',
                GOLD_REBATE: '黃金(每手佣金)',
                GOLD_COMMISSION: '黃金(內佣)',
                SILVER_LOT: '白銀(手數)',
                SILVER_REBATE: '白銀(每手佣金)',
                SILVER_COMMISSION: '白銀(內佣)',
                ENERGY_LOT: '能源(手數)',
                ENERGY_REBATE: '能源(每手佣金)',
                ENERGY_COMMISSION: '能源(內佣)',
                INDEX_LOT: '指數(手數)',
                INDEX_REBATE: '指數(每手佣金)',
                INDEX_COMMISSION: '指數(內佣)'
            },
            detailTh_v2: {
                IB_ID: '代理賬號',
                PLATFORM: '交易平台',
                CLIENT_ID: '客戶賬號',
                TRADING_ACCOUNT_ID: '交易賬號',
                FX_LOT: '外匯(手數)',
                FX_REBATE: '外匯(每手佣金)',
                FX_COMMISSION: '外匯(內佣)',
                GOLD_LOT: '黃金(手數)',
                GOLD_REBATE: '黃金(每手佣金)',
                GOLD_COMMISSION: '黃金(內佣)',
                SILVER_LOT: '白銀(手數)',
                SILVER_REBATE: '白銀(每手佣金)',
                SILVER_COMMISSION: '白銀(內佣)',
                ENERGY_LOT: '能源(手數)',
                ENERGY_REBATE: '能源(每手佣金)',
                ENERGY_COMMISSION: '能源(內佣)',
                INDEX_LOT: '指數(手數)',
                INDEX_REBATE: '指數(每手佣金)',
                INDEX_COMMISSION: '指數(內佣)'
            }
        }
    },
    en: {
        salesMonthlyResult: {
            indexText: 'Sales Monthly Commission Result',
            text: 'Sales Monthly Commission Result',
            datailText: 'Sales Monthly Commission Result Detail',
            goback: 'Go Back',
            start_time: "Start Time：",
            end_time: "End Time：",
            selectTimeText: 'Select Date',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            downloadExcelForms: "Download Excel",
            downloadDetailExcel: "Download Detail",
            search: "Search",
            nodata: "No data found",
            commissionType: 'Type：',
            salesAccount: 'Account：',
            status: 'Status：',
            confirm: 'Confirm',
            reject: 'Reject',
            rejectMessage: 'Please enter a reject reason',
            spread: 'Expand',
            fold: 'Collapse',
            commit: 'Do you really want to confirm/reject?',
            downloadName: 'Sales Monthly Commission Detail',
            selectKeys: { "id": "Account", "depositAccount": "Deposit Account" },
            typeList: { "-1": "All", "0": "Monthly Commission", "1": "Lower Level Commission" },
            statusList: { "-1": "All", "2": "Unconfirmed", "3": "Confirmed", "4": "Rejected" },
            indexStatusList: { "-1": "All", "0": "Unconfirmed", "1": "All Confirmed", "2": "Partially Confirmed" },
            client_type: { "0": "All Clients", "1": "IB", "2": "Sub Clients", "3": "Sub Clients(VIP)", "4": "IB(VIP)" },
            levelObj: {
                UN: 'SYSTEM',
                C: 'COMPANY',
                N: 'COUNTRY',
                R: 'REGION',
                O: 'OFFICE',
                M: 'MANAGER',
                SL: 'SALES',
                IB: 'IB',
                CL: 'CLIENT'
            },
            indexTh: [
                { key: 'REPORT_ID', name: 'Record ID' },
                { key: 'saleCommResult', name: 'Sales Commission Result', unneed: false },
                { key: 'DATE_FROM', name: 'Start Time' },
                { key: 'DATE_TO', name: 'End Time' },
                { key: 'LAST_UPDATE', name: 'Completion Time', changeTime: true },
                { key: 'status', name: 'Status' }
            ],
            detailTotal: {
                TOTAL_LOTS: 'Total Lot',
                TOTAL_REBATE: 'Rebate',
                TOTAL_COMMISSION: 'Staff Commission',
                TOTAL: '\'s Monthly Commission',
                index: 2,
                part: 'part'
            },
            total: { total: 'Total', index: 1, part: 'part' },
            commmissionTh: [
                { key: 'type', name: 'Commission Type' },
                { key: 'SALES_ID', name: 'Sales Account' },
                { key: 'NAME', name: 'Sales Name' },
                { key: 'level', name: 'Level' },
                { key: 'AMOUNT', name: 'Amount' },
                { key: 'status', name: 'Status' },
                { key: 'REJECT_REASON', name: 'Reject Reason' },
                { key: 'DEPOSIT_ORDER_ID', name: 'Order ID' },
                { key: 'DEPOSIT_COMMENT', name: 'Comment' },
                { key: 'UPDATE_BY', name: 'Update By' },
                { key: 'LAST_UPDATE', name: 'Last Update', changeTime: true }
            ],
            commmissionTh_v2: [
                { key: 'type', name: 'Commission Type' },
                { key: 'SALES_ID', name: 'Sales Account' },
                { key: 'NAME', name: 'Sales Name' },
                { key: 'level', name: 'Level' },
                { key: 'DEPOSIT_PLATFORM', name: 'Trade Platform' },
                { key: 'DEPOSIT_ACCOUNT_ID', name: 'Deposit Account' },
                { key: 'AMOUNT', name: 'Amount' },
                { key: 'status', name: 'Status' },
                { key: 'REJECT_REASON', name: 'Reject Reason' },
                { key: 'DEPOSIT_ORDER_ID', name: 'Order ID' },
                { key: 'DEPOSIT_COMMENT', name: 'Comment' },
                { key: 'UPDATE_BY', name: 'Update By' },
                { key: 'LAST_UPDATE', name: 'Last Update', changeTime: true }
            ],
            downloadTh: [
                { key: 'TYPE', name: 'Commission Type' },
                { key: 'SALES_ID', name: 'Sales Account' },
                { key: 'NAME', name: 'Sales Name' },
                { key: 'LEVEL', name: 'Level' },
                { key: 'AMOUNT', name: 'Amount' },
                { key: 'ID', name: 'Account' },
                { key: 'LOW_LEVEL', name: 'Level' },
                { key: 'CLIENT_TYPE', name: 'Client Type' },
                { key: 'TOTAL_VOLUME', name: 'Volume' },
                { key: 'REBATE', name: 'Rebate' },
                { key: 'TOTAL_COMMISSION', name: 'Total Commission' }
            ],
            downloadTh_v2: [
                { key: 'TYPE', name: 'Commission Type' },
                { key: 'SALES_ID', name: 'Sales Account' },
                { key: 'NAME', name: 'Sales Name' },
                { key: 'LEVEL', name: 'Level' },
                { key: 'AMOUNT', name: 'Amount' },
                { key: 'ID', name: 'Account' },
                { key: 'DEPOSIT_ACCOUNT', name: 'IB Deposit Account' },
                { key: 'LOW_LEVEL', name: 'Level' },
                { key: 'CLIENT_TYPE', name: 'Client Type' },
                { key: 'PLATFORM', name: 'Trading Platform' },
                { key: 'TOTAL_VOLUME', name: 'Volume' },
                { key: 'REBATE', name: 'Rebate' },
                { key: 'TOTAL_COMMISSION', name: 'Total Commission' }
            ],
            lowerTh: [
                { key: 'sub_sales_id', name: 'Sub Sales Account' },
                { key: 'NAME', name: 'Sales Name' },
                { key: 'level', name: 'Level' },
                { key: 'rule_id', name: 'Rule' },
                { key: 'VALUE', name: 'Rule Param' },
                { key: 'client_type', name: 'Client Type' },
                { key: 'TOTAL_VOLUME', name: 'Volume' },
                { key: 'RULE_COMMISSION', name: 'Total Commission' }
            ],
            detailTh: {
                IB_ID: 'IB Account',
                CLIENT_ID: 'Client Account',
                FX_LOT: 'FX(LOTS)',
                FX_REBATE: 'FX(Rebate)',
                FX_COMMISSION: 'FX(Internal Commission)',
                GOLD_LOT: 'GOLD(LOTS)',
                GOLD_REBATE: 'GOLD(Rebate)',
                GOLD_COMMISSION: 'GOLD(Internal Commission)',
                SILVER_LOT: 'SILVER(LOTS)',
                SILVER_REBATE: 'SILVER(Rebate)',
                SILVER_COMMISSION: 'SILVER(Internal Commission)',
                ENERGY_LOT: 'ENERGY(LOTS)',
                ENERGY_REBATE: 'ENERGY(Rebate)',
                ENERGY_COMMISSION: 'ENERGY(Internal Commission)',
                INDEX_LOT: 'INDEX(LOTS)',
                INDEX_REBATE: 'INDEX(Rebate)',
                INDEX_COMMISSION: 'INDEX(Internal Commission)'
            },
            detailTh_v2: {
                IB_ID: 'IB Account',
                PLATFORM: 'Platform',
                CLIENT_ID: 'Client Account',
                TRADING_ACCOUNT_ID: 'Trading Account',
                FX_LOT: 'FX(LOTS)',
                FX_REBATE: 'FX(Rebate)',
                FX_COMMISSION: 'FX(Internal Commission)',
                GOLD_LOT: 'GOLD(LOTS)',
                GOLD_REBATE: 'GOLD(Rebate)',
                GOLD_COMMISSION: 'GOLD(Internal Commission)',
                SILVER_LOT: 'SILVER(LOTS)',
                SILVER_REBATE: 'SILVER(Rebate)',
                SILVER_COMMISSION: 'SILVER(Internal Commission)',
                ENERGY_LOT: 'ENERGY(LOTS)',
                ENERGY_REBATE: 'ENERGY(Rebate)',
                ENERGY_COMMISSION: 'ENERGY(Internal Commission)',
                INDEX_LOT: 'INDEX(LOTS)',
                INDEX_REBATE: 'INDEX(Rebate)',
                INDEX_COMMISSION: 'INDEX(Internal Commission)'
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/Sale/salesMonthlyResult.js